import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { all_routes } from '../../../router/all_routes'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import PredefinedDateRanges from '../../../../core/common/datePicker'
import { allClass, allSection, gender, names, status } from '../../../../core/common/selectoption/selectoption'

import CommonSelect from '../../../../core/common/commonSelect'
import TooltipOption from '../../../../core/common/tooltipOption'
import UserService from '../../../network/services/UserService'
import { getUser } from '../../../network/auth/Auth'
import { Modal, Toast } from 'react-bootstrap'

import { getFirestore, collection, doc, setDoc, addDoc, updateDoc } from 'firebase/firestore'; // pour la version 9 et ultérieures
import { firestore } from '../../../../firebase'



const StudentGrid = () => {
  const routes = all_routes
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove('show');
    }
  };

  const navigation = useNavigate()

  interface SudentData {
    id: any;
    rfid_code: any;
    active: any;
    avatar: any;
    first_name: any;
    last_name: any;
    course_detail_ids: any;
    blood_group: any;
    gender: any;
    nationality: any
  }

  interface Option {
    id: any;
    name: any;
  }


  const [showDangerToast, setShowDangerToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [isActionSuccessful, setIsActionSuccessful] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [students, setStudents] = useState<SudentData[]>([]);
  const [branch, setBranch] = useState<any>();
  const branches = [];
  const [selectedRecord, setSelectedRecord] = useState<any>({
    first_name: '',
    last_name: '',
    email: '',
    gender: '',
    phone: '',
    password: '',
    birth_date: '',
    parent_name: '',
    parent_email: '',
    parent_phone: '',
    relationship_id: '',
  });

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleClose2 = () => setShowModal2(false);
  const handleShow2 = () => setShowModal2(true);

  const handleSuccessToastClose = () => {
    setShowSuccessToast(false);
  };

  const handleDangerToastClose = () => {
    setShowDangerToast(false);
  };


  const [selectedId, setSelectedId] = useState<any>();

  const [users, setUsers] = useState<any>([]);
  const getAllUsers = () => {
    console.log("users")
    console.log('goooooo--------------------------')

    UserService.getUsers((response: any) => {
      console.log(response.data)

      if (response?.success === true) {
        setUsers(response.data)
        console.log(response.data)
      }
    })
  }

  useEffect(() => {
    getAllUsers()
  }, [])



  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    gender: '',
    phone: '',
    password: '',
    birth_date: '',
    company_id: '',
    operating_branch_id: '',
    parent_name: '',
    parent_email: '',
    parent_phone: '',
    relationship_id: '',
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };


  const handleInputChangeEdite = (e: any) => {
    const { name, value } = e.target;
    setSelectedRecord((prevRecord: any) => ({
      ...prevRecord,
      [name]: value
    }));
  };

  const handleInputChangeEdite2 = (e: any) => {
    const { name, value } = e.target;
    console.log(`Changed ${name} to ${value}`); // Debugging

    setSelectedRecord((prevRecord: any) => ({
      ...prevRecord,
      [name]: {
        id: value,
        //  name: branches.find((branch: any) => branch.id === value)?.name || '' // Assurez-vous que `name` est mis à jour correctement
      }
    }));
  };

  const handleEdit = (record: any) => {
    setSelectedRecord(record)
    handleShow2()
  };




  interface Option {
    id: any;
    name: any;
  }
  const [relationShips, setRelationShips] = useState<Option[]>([]);
  const getAllARelation = async () => {
    await UserService.getRelationship((response: any) => {
      if (response?.data && response?.success) {
        setRelationShips(response.data)
      }
    })
  }







  const formatDate = (date: Date | string) => {
    if (!date) return '';

    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const year = d.getFullYear();

    return `${year}-${month}-${day}`;
  };

  const handleSubmit = () => {
    setIsLoading(true)
    const request_data = {

    };


    UserService.verifierAccount(selectedId?.id, request_data, async (response: any) => {
      console.log(response)
      if (response.success) {

        try {
          // Référence à l'utilisateur dans la collection 'users'
          const userRef = doc(collection(firestore, 'users'), selectedId?.id + "");

          // Mettre à jour le champ 'is_verified' dans Firestore
          await updateDoc(userRef, {
            is_verified: true,
          });

          console.log('User successfully verified and updated in Firebase.');

          setIsLoading(false);
          setSuccessMessage('User verified successfully and updated in Firebase.');
          setShowSuccessToast(true);
          setShowModal(false);
          getAllUsers(); // Récupérer tous les utilisateurs mis à jour
        } catch (error) {
          console.error('Error updating user in Firebase: ', error);
          setErrorMessage('Failed to update user in Firebase.');
          setShowDangerToast(true);
          setIsLoading(false);
        }
      } else {

        setErrorMessage(response?.message)
        setShowDangerToast(true)
        setIsLoading(false)
      }
    });
  };


  const handleSubmit2 = () => {
    setIsLoading(true)
    const request_data = {

    };


    UserService.unVerifierAccount(selectedId?.id, request_data, async (response: any) => {
      console.log(response)
      if (response.success) {

        try {
          // Référence à l'utilisateur dans la collection 'users'
          const userRef = doc(collection(firestore, 'users'), selectedId?.id + "");

          // Mettre à jour le champ 'is_verified' dans Firestore
          await updateDoc(userRef, {
            is_verified: false,
          });

          console.log('User successfully verified and updated in Firebase.');

          setIsLoading(false);
          setSuccessMessage('User verified successfully and updated in Firebase.');
          setShowSuccessToast(true);
          setShowModal(false);
          getAllUsers(); // Récupérer tous les utilisateurs mis à jour
        } catch (error) {
          console.error('Error updating user in Firebase: ', error);
          setErrorMessage('Failed to update user in Firebase.');
          setShowDangerToast(true);
          setIsLoading(false);
        }
      } else {

        setErrorMessage(response?.message)
        setShowDangerToast(true)
        setIsLoading(false)
      }
    });
  };









  const fetchData = async (branch_id: any, company_id: any, item: any) => {
    if (item) {
      setBranch(item.name);
    }
    setIsLoading(true)
    await UserService.getStudents(branch_id, company_id, (response: any) => {
      if (response?.data && response?.success) {
        setIsLoading(false)

        setStudents(response.data)

      } else {
        setIsLoading(false)
        setStudents([])
      }
    })

  };

  const fetchDataInit = async (company_id: any) => {
    setBranch('All');
    setIsLoading(true)
    await UserService.getStudentsAll(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setIsLoading(false)

        setStudents(response.data)

      }
    })

  };



  const navigeStudentDetails = (student: any) => {
    navigation(routes.studentDetail, { state: { student: student } })
  }

  const navigeStudentList = (students: any) => {
    navigation(routes.studentList, { state: { students: students } })
  }



  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content content-two">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Users</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Users</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Users Grid
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />

              <div className="mb-2">
                <a

                  className="btn btn-primary d-flex align-items-center"
                  onClick={handleShow}
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Users
                </a>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Filter */}
          <div className="bg-white p-3 border rounded-1 d-flex align-items-center justify-content-between flex-wrap mb-4 pb-0">
            <h4 className="mb-3">Users Grid</h4>
            <div className="d-flex align-items-center flex-wrap">
              <div className="input-icon-start mb-3 me-2 position-relative">
                <PredefinedDateRanges />
              </div>
              <div className="dropdown mb-3 me-2">
                <Link
                  to="#"
                  className="btn btn-outline-light bg-white dropdown-toggle"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                >
                  <i className="ti ti-filter me-2" />
                  Filter
                </Link>
                <div className="dropdown-menu drop-width" ref={dropdownMenuRef}>
                  <form>
                    <div className="d-flex align-items-center border-bottom p-3">
                      <h4>Filter</h4>
                    </div>
                    <div className="p-3 pb-0 border-bottom">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Class</label>
                            <CommonSelect
                              className="select"
                              options={allClass}
                              defaultValue={allClass[0]}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Section</label>
                            <CommonSelect
                              className="select"
                              options={allSection}
                              defaultValue={allSection[0]}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">Name</label>
                            <CommonSelect
                              className="select"
                              options={names}
                              defaultValue={names[0]}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Gender</label>
                            <CommonSelect
                              className="select"
                              options={gender}
                              defaultValue={gender[0]}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Status</label>
                            <CommonSelect
                              className="select"
                              options={status}
                              defaultValue={status[0]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-3 d-flex align-items-center justify-content-end">
                      <Link to="#" className="btn btn-light me-3">
                        Reset
                      </Link>
                      <Link to={routes.studentGrid} className="btn btn-primary" onClick={handleApplyClick}>
                        Apply
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
              <div className="d-flex align-items-center bg-white border rounded-2 p-1 mb-3 me-2">
                <a
                  onClick={() => navigeStudentList(students)}
                  className="btn btn-icon btn-sm me-1 bg-light primary-hover"
                >
                  <i className="ti ti-list-tree" />
                </a>
                <Link
                  to={routes.studentGrid}
                  className="active btn btn-icon btn-sm primary-hover"
                >
                  <i className="ti ti-grid-dots" />
                </Link>
              </div>
              <div className="dropdown mb-3">
                <Link to="#" className="btn btn-outline-light bg-white dropdown-toggle" data-bs-toggle="dropdown">
                  <i className="ti ti-sort-ascending-2 me-2" />
                  {branch}
                </Link>
                <ul className="dropdown-menu p-3">
                  <li >
                    <a className="dropdown-item rounded-1">
                      All
                    </a>
                  </li>

                </ul>
              </div>
            </div>
          </div>
          {/* /Filter */}
          <div className="row">
            {/* Student Grid */}


            {users && users?.map((item: any, index: any) => (
              <div className="col-xxl-3 col-xl-4 col-md-6 d-flex" key={index}>
                <div className="card flex-fill">
                  <div className="card-header d-flex align-items-center justify-content-between">
                    <a className="link-primary" onClick={() => navigeStudentDetails(item)}>
                      {item?.user?.phone}
                    </a>
                    <div className="d-flex align-items-center">
                      {item?.user?.is_verified ? (
                        <span className="badge badge-soft-success d-inline-flex align-items-center me-1">
                          <i className="ti ti-circle-filled fs-5 me-1" />
                          Verifier
                        </span>
                      ) : (
                        <span className="badge badge-soft-danger d-inline-flex align-items-center me-1">
                          <i className="ti ti-circle-filled fs-5 me-1" />
                          Non verifer
                        </span>
                      )
                      }

                      <div className="dropdown">
                        <Link
                          to="#"
                          className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="ti ti-dots-vertical fs-14" />
                        </Link>
                        <ul className="dropdown-menu dropdown-menu-right p-3">



                          <li>
                            <Link
                              className="dropdown-item rounded-1"
                              to="#"
                              data-bs-toggle="modal"
                              data-bs-target="#delete-modal"
                              onClick={() => setSelectedId(item.user)}
                            >
                              <i className="ti ti-check me-2" />
                              verifier compte
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="bg-light-300 rounded-2 p-3 mb-3">
                      <div className="d-flex align-items-center">
                        <a
                          className="avatar avatar-lg flex-shrink-0"

                          onClick={() => navigeStudentDetails(item)}
                        >
                          <img
                            // src={` data:image/png;base64,${item.avatar}`} 
                            src={`data:image/png;base64,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`}
                            className="img-fluid rounded-circle"
                            alt="img"
                          />
                        </a>
                        <div className="ms-2">
                          <h5 className="mb-0">
                            <a
                              onClick={() => navigeStudentDetails(item)}>{item?.user?.name} {item?.user?.surname}</a>
                          </h5>
                          <p>{item?.user?.phone}</p>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gx-2">
                      <div>
                        <p className="mb-0">Roles</p>
                        <p className="text-dark">{item?.blood_group}</p>
                      </div>

                      <div>
                        {item?.roles?.map((element: any) => (

                          <span className="badge badge-soft-primary d-inline-flex align-items-center me-1">

                            {element?.name}
                          </span>
                        ))}


                      </div>
                    </div>
                  </div>
                  <div className="card-footer d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <Link
                        to="#"
                        className="btn btn-outline-light bg-white btn-icon d-flex align-items-center justify-content-center rounded-circle  p-0 me-2"
                      >
                        <i className="ti ti-brand-hipchat" />
                      </Link>
                      <Link
                        to="#"
                        className="btn btn-outline-light bg-white btn-icon d-flex align-items-center justify-content-center rounded-circle  p-0 me-2"
                      >
                        <i className="ti ti-phone" />
                      </Link>
                      <Link
                        to="#"
                        className="btn btn-outline-light bg-white btn-icon d-flex align-items-center justify-content-center rounded-circle p-0 me-3"
                      >
                        <i className="ti ti-mail" />
                      </Link>
                    </div>
                    <a

                      onClick={() => navigeStudentDetails(item)}
                      className="btn btn-light btn-sm fw-semibold"
                    >
                      View
                    </a>
                  </div>
                </div>
              </div>))}

            {/* /Student Grid */}

            <div className="col-md-12 text-center">
              {
                isLoading ? (<Link to="#" className="btn btn-primary">
                  <span
                    className="spinner-border spinner-border-sm align-middle me-1"
                    role="status"
                    aria-hidden="true"
                  />
                  Load More ...
                </Link>) : (<Link to="#" className="btn btn-primary">
                  <i className="ti ti-loader-3 me-2" />
                  Load More
                </Link>)
              }

            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="delete-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form>
              <div className="modal-body text-center">
                <span className="delete-icon">
                  <i className="ti ti-check" />
                </span>
                <h4>Verifier le compte</h4>
                <p>
                  {selectedId?.is_verified === 0 ?
                    ("Vous souhaitez verifier ce compte.") : ("Vous souhaitez retirer la verification sur ce compte.")}
                </p>
                <div className="d-flex justify-content-center">
                  <>
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Fermer
                    </Link>
                    {
                      selectedId?.is_verified === 0 ?
                        (<Link to="#" className="btn btn-primary" data-bs-dismiss="modal" onClick={handleSubmit}>
                          Oui, Verifier
                        </Link>) : (<Link to="#" className="btn btn-primary" data-bs-dismiss="modal" onClick={handleSubmit2}>
                          Oui, retirer
                        </Link>)
                    }
                  </>

                </div>
              </div>
            </form>
          </div>
        </div>
      </div>



      <Modal show={showModal} onHide={handleClose} size={"xl"}>
        <Modal.Header >
          <Modal.Title>Add Student</Modal.Title>
          <button
            type="button"
            className="btn-close custom-btn-close"
            onClick={handleClose}

          >
            <i className="ti ti-x" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">First Name</label>
                    <input type="text" className="form-control" placeholder="First Name" name="first_name" value={formData.first_name}
                      onChange={handleInputChange} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Last Name</label>
                    <input type="text" className="form-control" name="last_name" value={formData.last_name} placeholder="Last Name"
                      onChange={handleInputChange} />

                  </div>
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input type="email" className="form-control" name="email"
                      value={formData.email}
                      onChange={handleInputChange} placeholder="Email" />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Phone</label>
                    <input type="number" className="form-control" name="phone" value={formData.phone} placeholder="Phone"
                      onChange={handleInputChange} />

                  </div>
                  <div className="mb-3">
                    <label className="form-label">Birth Date</label>
                    <input type="date" className="form-control" name="birth_date"
                      value={formData.birth_date}
                      onChange={handleInputChange} placeholder="Birth date" />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Gender</label>
                    <select

                      className="select react-select form-control"
                      name="gender"
                      onChange={handleInputChange}
                    >
                      <option >Select Gender</option>

                      <option value="m">Male</option>
                      <option value="f">Female</option>


                    </select>
                  </div>






                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Branch</label>
                    <select

                      className="select react-select form-control"
                      name="operating_branch_id"
                      onChange={handleInputChange}
                    >
                      <option >All</option>
                      {/*    {branches && branches?.map((item: any) => (
                        <option key={item.id} value={item.id}>{item.name}</option>
                      ))} */}

                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Parent Name</label>
                    <input type="text" className="form-control" placeholder="Parent Name" name="parent_name" value={formData.parent_name}
                      onChange={handleInputChange} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Parent Phone</label>
                    <input type="text" className="form-control" name="parent_phone" value={formData.parent_phone} placeholder="Parent Phone"
                      onChange={handleInputChange} />

                  </div>
                  <div className="mb-3">
                    <label className="form-label">Parent Email</label>
                    <input type="email" className="form-control" name="parent_email"
                      value={formData.parent_email}
                      onChange={handleInputChange} placeholder="Parent Email" />
                  </div>


                  <div className="mb-3">
                    <label className="form-label">
                      Relationship
                    </label>



                    <select
                      className="form-select"
                      aria-label="Default select example"
                      onChange={handleInputChange}
                      name="relationship_id"
                    >
                      <option >Choisir</option>
                      {
                        relationShips && relationShips?.map(item => (
                          <option value={item.id}>{item?.name}</option>
                        ))
                      }

                    </select>

                  </div>


                </div>
              </div>
            </div>
            <div className="modal-footer">
              <span
                className="btn btn-light me-2"
                onClick={handleClose}
              >
                Cancel
              </span>
              <Link to="#" className="btn btn-primary" onClick={handleSubmit}  >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm align-middle me-1"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </>
                ) : "Add Student"}

              </Link>
            </div>
          </form>
        </Modal.Body>

      </Modal>



      <Toast
        show={showDangerToast}
        onClose={handleDangerToastClose}
        id="dangerToast"
        className="toast-container position-fixed top-0 end-0 p-3 colored-toast bg-danger-transparent"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={{ minWidth: "200px!important" }}
      >
        <Toast.Header closeButton className="bg-danger text-fixed-white">
          <strong className="me-auto">Message</strong>
          <span
            className="cursor-pointer"
            onClick={handleDangerToastClose}
            aria-label="Close"
            style={{ cursor: "pointer" }}
          />
        </Toast.Header>
        <Toast.Body>
          {/* Add your toast content here */}
          {errorMessage}
        </Toast.Body>
      </Toast>

      <Toast
        show={showSuccessToast}
        onClose={handleSuccessToastClose}
        id="successToast"
        className="toast-container position-fixed top-0 end-0 p-3  colored-toast bg-success-transparent"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >

        <Toast.Body>
          {/* Add your toast content here */}
          {successMessage}
        </Toast.Body>
      </Toast>
    </>

  )
}

export default StudentGrid